const boxesLocale = {
    months: new Array(12).fill("□□□□□□") as Array<string>,
    monthsShort: new Array(12).fill("□□□") as Array<string>,
    weekdays: new Array(7).fill("□□□□□") as Array<string>,
    weekdaysShort: new Array(7).fill("□□□") as Array<string>,
    weekdaysMin: new Array(7).fill("□") as Array<string>,
    longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY H:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
    },
    calendar: {
        sameDay: "[□□□] LT",
        nextDay: "[□□□] LT",
        nextWeek: "[□□□] dddd LT",
        lastDay: "[□□□] LT",
        lastWeek: "[□□□] dddd LT",
        sameElse: "L",
    },
    relativeTime: {
        future: "□□□ %s",
        past: "□□□ %s",
        s: "□□□",
        m: "□□□",
        mm: "%d □□□",
        h: "□□□",
        hh: "%d □□□",
        d: "□□□",
        dd: "%d □□□",
        M: "□□□",
        MM: "%d □□□",
        y: "□□□",
        yy: "%d □□□",
    },
    ordinalParse: /\d{1,2}□/ as RegExp,
    ordinal: "%d□",
    meridiemParse: /□□|□□□/ as RegExp,
    isPM: function (token: string): boolean {
        return token === "□□□";
    },
    meridiem: function (hour: number): string {
        return hour < 12 ? "□□" : "□□□";
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
} as const;

export default boxesLocale;
